import { FormStore } from '@roc/feature-app-core';
import { amortizationOptions } from '@roc/feature-loans';
import {
  trueFalseOptions,
} from '@roc/ui';
import {
  createRadioField,
  createSelectField,
} from '../../propertyBuilderTemp';
import { observer } from 'mobx-react';

interface Props {
  store: any;
  loanEconomicsStore: any
}

export enum RateTypeOptions {
  FIVE_SIX_ARM = '5/6 ARM',
  SEVEN_SIX_ARM = '7/6 ARM',
  TEN_SIX_ARM = '10/6 ARM',
  THIRTY_YEAR_FRM = '30 Yr FRM'
}
export const rateTypeOptions = [
  {
    label: '5/6 ARM',
    value: RateTypeOptions.FIVE_SIX_ARM,
  },
  {
    label: '7/6 ARM',
    value: RateTypeOptions.SEVEN_SIX_ARM,
  },
  {
    label: '10/6 ARM',
    value: RateTypeOptions.TEN_SIX_ARM,
  },
  {
    label: '30 Yr FRM',
    value: RateTypeOptions.THIRTY_YEAR_FRM,
  },
];
export const CashOut = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createRadioField({
        label: 'Are you seeking cash out?',
        fieldName: 'cashOut',
        testId: 'cashOut',
        store,
        options: trueFalseOptions,
        row: true,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});

export const Amortization = observer(({ store, loanEconomicsStore }: Props) => {
  return (
    <>
      {createSelectField({
        store,
        testId: 'amortization',
        fieldName: 'amortization',
        label: 'Amortization Type',
        options: amortizationOptions,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true,
        onChange: value => {
          loanEconomicsStore.loanEconomicsFormStore.onFieldChange('amortization', value);
          loanEconomicsStore.fetchRatesAndLoanTermsV2();
          loanEconomicsStore.fetchRatesForCustomQuotes();
        },
      })}
    </>
  );
});
export const RateType = observer(({ store, loanEconomicsStore }: Props) => {
  return (
    <>
      {createSelectField({
        store,
        testId: 'rateType',
        fieldName: 'rateType',
        label: 'Rate Type',
        options: rateTypeOptions,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true,
        onChange: value => {
          loanEconomicsStore.loanEconomicsFormStore.onFieldChange('rateType', value);
          loanEconomicsStore.fetchRatesAndLoanTermsV2();
          loanEconomicsStore.fetchRatesForCustomQuotes();
        },
      })}
    </>
  );
});
export const PrePenaltyPayment = observer(({ store, loanEconomicsStore }: Props) => {
  return (
    <>
      {createSelectField({
        store,
        testId: 'prepenaltyPayment',
        fieldName: 'prepenaltyPayment',
        label: 'Pre-Payment Penalty',
        options: loanEconomicsStore.prepaymentPenaltyOptions,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true,
        onChange: value => {
          loanEconomicsStore.loanEconomicsFormStore.onFieldChange('prepenaltyPayment', value);
          loanEconomicsStore.fetchRatesAndLoanTermsV2();
          loanEconomicsStore.fetchRatesForCustomQuotes();
        },
      })}
    </>
  );
});